import { InvoiceStatusEnum, SoLifeCycleStatusEnum, SoProcessTypesEnum, SoTypesEnum } from '@gtpl/shared-models/common-models';
import { ApiProperty } from '@nestjs/swagger';
export class SaleOrderTrackDTO {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderNumber: string;
    @ApiProperty()
    customer: string;
    @ApiProperty()
    orderedDate: Date;
    @ApiProperty()
    expectedEndDate: Date;
    @ApiProperty()
    orderQty: number;
    @ApiProperty()
    cost: number;
    @ApiProperty()
    destination: string;
    @ApiProperty()
    status: string;
    @ApiProperty()
    rmStock: number;
    @ApiProperty()
    process: string;
    @ApiProperty()
    packing: string;
    @ApiProperty()
    qualityAssurance: string;
    @ApiProperty()
    logistics: string;
    @ApiProperty()
    doc: string;
    @ApiProperty()
    fgStock: number;
    @ApiProperty()
    unit: number;
    @ApiProperty()
    product: string;
    @ApiProperty()
    poDate: Date;
    @ApiProperty()
    poNumber: string;
    @ApiProperty()
    endCustomername: string;
    @ApiProperty()
    countryName: string;
    @ApiProperty()
    totnetWeight: number;
    @ApiProperty()
    loadType: boolean;
    @ApiProperty()
    currencyId: number;
    @ApiProperty()
    currency: string;
    @ApiProperty()
    uom: number;
    @ApiProperty()
    isInvoiced: string;
    @ApiProperty()
    buyerPONo: string;
    @ApiProperty()
    soType: SoTypesEnum;
    @ApiProperty()
    soProcessType: SoProcessTypesEnum;
    @ApiProperty()
    actualEtd: Date;
    @ApiProperty()
    prodStatus: InvoiceStatusEnum;
}

export class SaleOrderTrackFilters{
    @ApiProperty()
    selectedEstimatedFromDate:string;
    @ApiProperty()
    selectedEstimatedToDate:string;
    @ApiProperty()
    saleOrderStatus:string[];
    @ApiProperty()
    selectedEndCustomer:number;
    @ApiProperty()
    unit:number;
    @ApiProperty()
    prodUnit?:number;
    @ApiProperty()
    destinations?:number[];
    @ApiProperty()
    countryId?:number;
    @ApiProperty()
    selectedCreatedFromDate?:string;
    @ApiProperty()
    selectedCreatedToDate?:string;
    @ApiProperty()
    masterBrandId?:number;
    @ApiProperty()
    varientCode?:number;
    @ApiProperty()
    readyForShipment?:number;
    @ApiProperty()
    mainCategory?:string[];
    @ApiProperty()
    lifeCycleStatus?:string;
    @ApiProperty()
    cardType?:string;
  }